<input
  type="file"
  (change)="onFileChange($event)"
  style="display: none"
  id="fileInput"
  accept=".xlsx"
/>

<p-dialog
  [header]="'excel.popup-header' | translate"
  [(visible)]="visible"
  [modal]="true"
  [maximizable]="true"
  [closable]="true"
  [resizable]="true"
  (onHide)="onClose()"
  [style]="{ width: step == 1 ? '40vw' : '70vw' }"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <span>{{ "excel.popup-header" | translate }}</span>
    </div>
  </ng-template>

  <div>
    <div [ngSwitch]="step">
      <div *ngSwitchCase="1">
        <p-table
          [value]="importedHeaders"
          [scrollable]="true"
          scrollHeight="75vh"
          responsiveLayout="scroll"
          class="custom-table"
        >
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{ "excel.excel-header" | translate }}</th>
              <th scope="col">{{ "excel.related-parameter" | translate }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-header let-i="rowIndex">
            <tr>
              <td>{{ header }}</td>
              <td>
                <p-dropdown
                  [(ngModel)]="mapping[i].appField"
                  [options]="realHeaders"
                  appendTo="body"
                  [placeholder]="'common.choose' | translate"
                  [showClear]="true"
                  [filter]="true"
                  (ngModelChange)="onFieldChange(i, $event)"
                  [style]="{ width: '100%' }"
                >
                </p-dropdown>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div *ngSwitchCase="2">
        <div *ngIf="showProgressBar">
          <p-progressBar [value]="loadingValue">
            <ng-template pTemplate="content" let-value>
              <span>{{ loadingValue }}/100</span>
            </ng-template>
          </p-progressBar>
          <div>{{ "excel.table-creating" | translate }}</div>
        </div>

        <div
          class="table-container"
          *ngIf="acceptedArray.length > 0 && !showProgressBar"
        >
          <h4 class="table-header">{{ "excel.accepted-datas" | translate }}</h4>
          <p-table
            *ngIf="acceptedArray.length > 0 && !showProgressBar"
            [scrollable]="true"
            scrollHeight="40vh"
            [tableStyle]="{ 'min-width': '40rem' }"
            class="p-datatable-sm"
            [value]="acceptedArray"
            [(selection)]="selectedDatas"
          >
            <ng-template pTemplate="header">
              <tr>
                <th scope="col"  style="width: 10%;" class="table-header"><p-tableHeaderCheckbox /></th>

                <th scope="col" style="width: 10%;"
                  *ngFor="let col of acceptedArrayHeaders"
                  class="table-header"
                >
                  <span
                    class="justify-content-center"
                  >
                    {{ col.label }}
                    </span
                  >
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
              <tr>
                <td style="padding: 10px">
                  <p-tableCheckbox [value]="rowData" />
                </td>
                <td
                  style="padding: 10px"
                  *ngFor="let col of acceptedArrayHeaders"
                >
                <span [ngSwitch]="col?.type">
                  <span *ngSwitchCase="'date'">
                    {{rowData[col.value] | date:'dd.MM.yyyy' }}
                  </span>
                  <span *ngSwitchCase="'number'">
                    {{rowData[col.value] | numberComma}}
                  </span>
                  <span *ngSwitchCase="'boolean'">
                    {{rowData[col.value]===true ? '+' : rowData[col.value]===false ? '-':'' }}
                  </span>
                  <span *ngSwitchDefault>
                      {{rowData[col.value]}}
                  </span>

                </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div
          class="table-container mt-4"
          *ngIf="failedArray.length > 0 && !showProgressBar"
        >
          <h4 class="table-header">{{ "excel.rejected-datas" | translate }}</h4>
          <p-table
            *ngIf="failedArray.length > 0 && !showProgressBar"
            [scrollable]="true"
            scrollHeight="40vh"
            [tableStyle]="{ 'min-width': '40rem' }"
            class="p-datatable-sm"
            [value]="failedArray"
          >
            <ng-template pTemplate="header">
              <tr>
                <th scope="col" *ngFor="let col of failedArrayHeaders" class="table-header" style="width: 10%;">
                  <span
                  class="justify-content-center"
                >
                  {{ col.label }}
                  </span
                >
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr>
                <td   style="padding: 10px">
                  <div *ngIf="rowData?.failedMessages?.length > 0">
                    <ul>
                      <li
                        class="error-message"
                        *ngFor="let err of rowData.failedMessages"
                      >
                        {{ err }}
                      </li>
                    </ul>
                  </div>
                </td>
                <td   style="padding: 10px"
                  *ngFor="let col of failedArrayHeaders; let i = index"
                  [hidden]="i === 0"
                >
                <span [ngSwitch]="col?.type">
                  <span *ngSwitchCase="'date'">
                    {{rowData[col.value] | date:'dd.MM.yyyy' }}
                  </span>
                  <span *ngSwitchCase="'number'">
                    {{rowData[col.value] | numberComma}}
                  </span>
                  <span *ngSwitchCase="'boolean'">
                    {{rowData[col.value]===true ? '+' : rowData[col.value]===false ? '-':'' }}
                  </span>
                  <span *ngSwitchDefault>
                      {{rowData[col.value]}}
                  </span>

                </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="excel-footer-dialog">
      <button type="button" (click)="onClose()" class="btn btn-danger">
        {{ "common.cancel" | translate }}
      </button>
      <button
        type="button"
        *ngIf="step == 2"
        (click)="stepBack()"
        class="btn btn-info"
      >
        {{ "excel.back" | translate }}
      </button>
      <button
        type="button"
        [disabled]="(step == 1 && !isMappingValid()) || (step !== 1 && selectedDatas?.length==0)"
        (click)="step == 1 ? saveMapping() : saveSelectedDatas()"
        class="btn btn-success"
      >
        {{
          step == 1 ? ("excel.next" | translate) : ("common.save" | translate)
        }}
      </button>
    </div>
  </ng-template>
</p-dialog>
